
import Panel from 'vux/src/components/panel/index.vue'
import Cell from 'vux/src/components/cell/index.vue'

import {Dialog} from "vant";

export default {
components: {
Panel,
Cell
},
data() {
return {
apiurl: "",
orderList: []
};
},

created() {},

beforeMount() {},

mounted() {
let _this = this
_this.$http.get("./static/api/api.json").then(response => {
_this.apiurl = response.api;
_this.getOrderList();
});
},
methods: {
pay(id){
Dialog.confirm({
title: '支付',
message: '确定立即支付吗？',
})
.then(() => {

let _this = this;
_this.$http
.post(_this.apiurl + "/web/order/pay/" + id)
.then((res) => {
if (res.code === 0) {
wx.chooseWXPay({
timestamp: res.data.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
nonceStr: res.data.nonceStr, // 支付签名随机串，不长于 32 位
package: res.data.packageValue, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
signType: res.data.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
paySign: res.data.paySign, // 支付签名
success: function (res) {

_this.$vux.toast.text("支付成功", "top");
_this.$router.push({
path: "/deviceList",
});
},
});
} else {
_this.$vux.toast.text(res.msg, "top");
}
});
})
.catch(() => {

});
},
getOrderList() {
this.loading = true;
this.$http
.get(this.apiurl + "/web/order/list")
.then(res => {
if (res.code === 0) {
this.orderList = res.data;
}
this.loading = false;
});
},
}
};



// WEBPACK FOOTER //
// ./src/components/order.vue